import { PhaseOutput } from 'phase/model/phase.output';

export abstract class PhaseApiPort {
	public abstract fetchPhasesByUserId(userId: string): Promise<PhaseOutput[]>;
}
